export default {
    acquiring_device: "Пристрій прийому платежів",
    add_expense: "Додати витрати",
    add_income: "Додати дохід",
    advance_noun: "Аванс",
    all_pay_methods: "Всі способи оплати",
    bank_terminal: "Банківський термінал",
    cash_operation: "Касова операція",
    cashdesk: "Каса",
    cashier: "Касир",
    cashier_inn: "ІПН касира",
    cashier_name: "Ім'я касира",
    cashless_payment: "Безготівковий розрахунок",
    cashless_payments: "Безготівковий розрахунок",
    cheque: "Чек",
    cheque_generation_in_process_status_might_change_later: "Генерація чека в процесі. Зміна статусу може зайняти деякий час.",
    cheques: "Чеки",
    close_shift: "Закрити зміну",
    closing_balance: "Залишок на кінець дня",
    create_cheque: "Сформувати фіскальний чек",
    dashboard: "Приладова панель",
    data_is_invalid: "Дані невалідні",
    data_is_valid: "Дані валідні",
    deposit_to_cashdesk: "Внести в касу",
    enter_amount: "Введіть суму",
    enter_the_cheque_number: "Введіть номер чека",
    error_printing_cheque: "Помилка друку чека",
    fiscal_cheque_copy_print: "Друк копії фіскального чека",
    fiscal_cheque_print: "Друк фіскального чека",
    fiscal_device: "Пристрій ККТ",
    fiscal_registrar: "Фіскальний реєстратор",
    fiscal_registrar_management: "Управління фіскальним реєстратором",
    fixed: "Фіксований",
    injection: "Поповнення",
    issue_an_advance: "Видати аванс",
    kkm_url: "HTTP-адреса сервера торгового обладнання. Заповнювати у випадку, якщо ккм сервер підключений нелокально.",
    market_as_fiscal_cheque_manually: "Позначити як фіскальний чек вручну",
    name_of_service_in_cheque: "Назва послуги в чеку",
    not_subject_to_vat: "Не оподатковується ПДВ",
    only_for_payment_through_terminal: "Тільки для оплати через термінал",
    open_shift: "Відкрити зміну",
    opened_at: "Дата відкриття",
    opening_balance: "Залишок на початок дня",
    partial_prepayment: "Часткова передоплата",
    print_totals: "Друк підсумків",
    process_advances_as: "Чеки передоплати проводити як",
    sale_of_goods: "Продаж Товарів",
    sales: "Продажі",
    send_services_in_cheque: "Передавати послуги в чеку",
    shift: "Зміна",
    shift_number: "Номер зміни",
    shifts: "Зміни",
    system_to_use: "Використовувати систему",
    terminal: "Термінал",
    totals: "Підсумки",
    vat_rate: "Ставка ПДВ",
    waiting_for_payment_in_terminal: "Очікуємо оплату на терміналі",
    who_accepts_payment: "Хто приймає оплату",
    withdraw_from_cashdesk: "Зняти з каси",
    withdrawal: "Вилучення",
    withdrawal_replenishment_from_the_cash_register: "Зняття / Поповнення З Каси",
    withdrawal_replenishment_of_cash: "Зняття/поповнення готівки",
    xreport: "X-звіт",
    xreports: "X-звіти"
}
